
    import * as React from 'react';

    const Undo24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M6.47081 4.72324C9.31648 3.04921 12.9302 2.81867 16.0899 4.42866C21.0108 6.93598 22.9674 12.9577 20.4601 17.8786C17.9528 22.7995 11.931 24.7561 7.01013 22.2488C3.54597 20.4837 1.55085 16.977 1.5479 13.3387L2.61956 13.3387C2.62219 16.5872 4.40355 19.7182 7.49654 21.2941C11.8902 23.5328 17.2668 21.7859 19.5054 17.3922C21.7441 12.9986 19.9972 7.62199 15.6035 5.38331C12.7151 3.91159 9.40191 4.16239 6.8347 5.75528L10.8425 6.37073L10.6799 7.42974L4.54568 6.48777L6.99747 0.7865L7.98175 1.20978L6.47081 4.72324Z" /></svg>
        </div>
      );
    };

    Undo24.displayName = 'Undo24';

    export default Undo24;
  